export class Answer {
  id!: number | null;
  label: string;
  image: string | null;
  selected?: boolean = false;
  is_drag_over?: boolean;
  ref_bdd?: string;

  constructor(id: number | null, label: string, selected: boolean = false, image: string | null = null, is_drag_over: boolean = false, ref_bdd: string = '') {
    this.id = id;
    this.label = label;
    this.selected = selected;
    this.image = image;
    this.is_drag_over = is_drag_over;
    this.ref_bdd = ref_bdd;
  }
}

export class AnswerExplanation {
  title!: string;
  text!: string;
  image?: string;
  small_texts?: { [key: number]: string };
  color_title?: string;
  additional_text_title?: string;
}
